/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Importing_MediaInputs */



/**
* | output |
* | --- |
* | "Importing media..." |
*
* @param {Load_Project_File_Status_Importing_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_importing_media = /** @type {((inputs?: Load_Project_File_Status_Importing_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Importing_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des medias...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione dei contenuti multimediali...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando medios...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入媒体...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando mídia...")
	return /** @type {LocalizedString} */ ("Importing media...")
});